<template>
  <div
    class="checkable-button"
    tabindex="0"
    role="checkbox"
    :aria-checked="isChecked"
    @click="handleToggle"
    @keydown.enter.prevent="handleToggle"
    @keydown.space.prevent="handleToggle"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CheckableButton',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isChecked() {
      return this.value;
    }
  },
  methods: {
    handleToggle() {
      this.$emit('change', !this.value);
      this.$emit('input', !this.value);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkable-button {
  user-select: none;
  cursor: pointer;
  background-color: transparent;
  margin: 0;

  /** @note Necessary rule to reset some unnecessary inherited styles (Due to the usage of style tag without scoped). */
  height: auto;
  font-size: medium;
  font-weight: normal;
  border: initial;
  transition: none;
  animation-duration: initial;
  color: initial;
  border-radius: 0;
}
</style>
